<template>
  <div v-if="isLoaded">
    <v-card elevation="0" class="mr-4">
      <v-card-title class="display-1 text--primary"
        >Single-Sign-On (SSO) for Ikano AWS</v-card-title
      >
      <v-card-text>
        <p class="text--primary">You can access Ikano AWS through SSO</p>
        <p v-if="workspace.State">
          The password and MFA for logging on to AWS
          <bold>and</bold>your workspace are the same.
        </p>

        <p>
          <a href="https://ikano.awsapps.com/start#/" class="link-large"
            >https://ikano.awsapps.com/start#/</a
          >
        </p>
      </v-card-text>
    </v-card>

    <workspace v-if="$store.state.workSpace.State && newUser" />

    <v-card class="ma-auto mt-10" elevation="0">
      <v-card-title class="display-1">Your profile</v-card-title>
      <v-card-text>
        <v-list v-if="$store.state.userDetails.userDetails">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="title">Name</v-list-item-title>
              <v-list-item-subtitle>{{
                $store.state.userDetails.userDetails.cn
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="mt-5">
            <v-list-item-content>
              <v-list-item-title class="title">Email</v-list-item-title>
              <v-list-item-subtitle>{{
                $store.state.userDetails.userDetails.mail
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="mt-5">
            <v-list-item-content>
              <v-list-item-title class="title">Phone</v-list-item-title>
              <v-list-item-subtitle>{{
                $store.state.userDetails.userDetails.telephoneNumber
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <!-- <v-card class="mt-10" v-if="allowPasswordReset">
      <v-card-title>Change password</v-card-title>
      <v-card-text>
        <p>Change your password for SSO and workspace.</p>
      </v-card-text>
      <v-card-actions>
        <v-btn class="mt-10" to="/change-password">Change password</v-btn>
      </v-card-actions>
    </v-card> -->

    <v-card
      class="ma-auto mt-10"
      elevation="0"
      v-if="$store.state.workSpace.State && !newUser"
    >
      <v-card-title class="display-1">Workspace</v-card-title>
      <v-card-text>
        <router-link to="/workspace">See your workspace state</router-link>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import router from "../router";
import Workspace from "../components/Workspace.vue";

export default {
  components: {
    Workspace
  },
  data() {
    return {
      dialog: false,
      newUser: false,
      workspace: {},
      allowPasswordReset: false
    };
  },
  async created() {
    const flags = await this.$store.dispatch("flags");
    this.allowPasswordReset = flags.ALLOW_PASSWORD_RESET;

    console.log(flags);

    const routeMapper = {
      "init-user": flags.FORCE_RESET_PASSWORD && flags.FORCE_RESET_MFA,
      "mfa-setup": flags.FORCE_RESET_MFA,
      "change-password": flags.FORCE_RESET_PASSWORD
    };

    const accomplished = {
      "init-user":
        this.$store.state.didSetPassword && this.$store.state.didSetMfa,
      "mfa-setup": this.$store.state.didSetPassword,
      "change-password": this.$store.state.didSetMfa
    };

    const routeIndex = Object.values(routeMapper).indexOf(true);

    if (routeIndex > -1) {
      const routeName = Object.keys(routeMapper)[routeIndex];

      const hasChangedForced =
        routeMapper[routeName] !== accomplished[routeName];

      this.newUser =
        (accomplished["init-user"] === routeMapper["init-user"]) === true; //new-user is assumed to be one with has forced on both pwd and mfa and has changed both
      // TODO if only one has been accomplished, it will be set as new user

      if (hasChangedForced) {
        this.$store.commit("setNewUser", true);

        router.push(`/${routeName}`);
      }
    }

    await this.$store.dispatch("getWorkSpace");
    await this.$store.dispatch("userDetails");
  },

  computed: {
    name() {
      return ` ${this.$store.state.userDetails.userDetails.cn} ` || "";
    },
    isLoaded() {
      return this.$store.state.userDetails.userDetails;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
